<template>
  <Modal
    v-if="socialType === ContentSocialType.FACEBOOK"
    hide-footer
    :size="ModalSize.XL"
    :title="$t('content.social-post')"
    hide-title
    closable
  >
    <template #activator>
      <button type="button">
        <slot />
      </button>
    </template>
    <template #body>
      <div
        class="md:grid md:grid-cols-10 bg-[black] md:bg-[white] h-full rounded-md overflow-hidden"
      >
        <div
          class="h-full w-full col-span-7 bg-[black] flex items-center justify-center"
        >
          <Carousel
            :variant="CarouselVariant.SLIDER"
            :files="carouselFiles"
            :slider-background-variant="SliderBackgroundVariant.BLACK"
            @active-index-update="activeIndex = $event"
          />
        </div>
        <div
          class="text-[white] py-5 md:py-0 max-h-60 md:max-h-full overflow-y-auto md:h-full w-full md:pt-15 px-5 md:pr-10 col-span-3 md:text-secondary text-left"
        >
          {{ socialFiles[activeIndex]?.caption }}
        </div>
      </div>
    </template>
  </Modal>
  <slot v-else />
</template>
<script setup lang="ts">
import { ModalSize, Modal } from '@exfluential/ui';
import { ContentSocialFileDto, ContentSocialType } from '~/api/contents';
import {
  Carousel,
  CarouselVariant,
  SliderBackgroundVariant,
} from '~/components/carousel';

type Props = {
  socialFiles: ContentSocialFileDto[];
  socialType: ContentSocialType;
};

const props = defineProps<Props>();
const activeIndex = ref<number>(0);
const carouselFiles = computed(() =>
  props.socialFiles.map(({ file }) => ({
    id: file.id,
    src: file.url,
  })),
);
</script>
